<template>
  <div class="app">
    <Card dis-hover>
      <Form ref="queryForm" :label-width="70" label-position="left" inline>
        <Row :gutter="16">
          <Col span="4">
          <FormItem label="用户名：" :label-width="70">
            <Input type="text" placeholder="请输入" v-model="form.Name" style="width:150px"></Input>
          </FormItem>
          </Col>
          <Col span="4">
          <FormItem label="年份:" :label-width="50" style="width: 100%">
            <DatePicker type="year" @on-change="form.Year=$event" v-model="form.Year" placeholder="请选择" :editable="false" style="width:180px; padding-right:20px;"></DatePicker>
            <!-- <FormItem label="年份:" :label-width="80">
					   <Select placeholder="请选择年份"  style="width: 180px" v-model="query.post">
					 	<Option value="">------</Option>
					 	<Option v-for="item in postList" :key="item.value" :value="item.value">{{ item.name }}</Option>
					   </Select>
					 </FormItem> -->
          </FormItem>
          </Col>
          <Button icon="ios-search" type="primary" size="default" @click="getData" class="toolbar-btn">查询</Button>
          <Button icon="md-refresh" type="primary" size="default" @click="reset" class="toolbar-btn">重置</Button>
          <Button type="success" icon="md-archive" @click="importT" class="toolbar-btn">导入</Button>&nbsp;&nbsp;
          <Button icon="md-archive" type="primary" size="default" @click="downLoadTemplate" class="toolbar-btn">下载导入模板</Button>
          <Button type="success" icon="md-archive" @click="exportFile" class="toolbar-btn">导出</Button>&nbsp;&nbsp;
          <Button icon="md-refresh" type="primary" size="default" @click="resetLastYearUserLeaves" v-if="fromFields.isShow核销==true" class="toolbar-btn">核销去年结余假期</Button>
          <!-- <Upload :before-upload="beforeImportFile" :on-success="importFile" :on-error="errorImportFile" :headers="requestHeader" accept=".xlsx,.xls,.excel" :show-upload-list="false" :action="action" :data="importData">
			      <Button icon="md-add" type="primary" size="default" class="toolbar-btn">导入数据</Button>
			  </Upload> -->
        </Row>
      </Form>
      <div class="table_body">
        <Table ref="table" border :loading="loading" :columns="columns" :no-data-text="NoDatas" :data="tableBody_item"></Table>

        <div style="margin-top: 10px;">
          <Page show-sizer show-elevator show-total :current="current" :total="totalCount" @on-change="pageChange" @on-page-size-change="pagesizeChange"></Page>
        </div>
      </div>
    </Card>
    <!-- 新增/编辑弹出框 -->
    <newdate-table :value="testModal" :type='modelType' @close="close" ref="newID"></newdate-table>
    <!-- 导入 -->
    <date-import :value="testDate" @close="closeDate" ref="importDay"></date-import>
    <!-- 操作日志弹出框 -->
    <operation :value="testLog" @close="closeLog" ref="logID"></operation>

  </div>
</template>
<script>
import Util from '../../../lib/util'
import moment from 'moment'
import newdateTable from './newdateTable.vue'
import dateImport from './dateImport.vue'
import operation from './operation.vue'
import { resetLastYearUserLeave } from '../../../api/index'

export default {
  name: 'personholiday',
  props: {},
  components: {
    newdateTable,
    dateImport,
    operation,
  },
  filters: {
    formData(val) {
      return moment(val).format('YYYY-MM-DD')
    },
  },
  data() {
    return {
      totalCount: 0, //总共多少页
      current: 1, //当前第几页
      testModal: false,
      testDate: false,
      testLog: false,
      form: {
        Name: '',
        UserId: '',
        Year: '',
        SkipCount: 0, //从第几条开始爬
        MaxResultCount: 10, //一页多少条
      },
      NoDatas: '暂无数据',
      action: this.$constDefinition.baseUrl + '/Leavefile/Upload',
      spinShow: false,
      importData: {},
      requestHeader: {
        Authorization: `Bearer ${Util.abp.auth.getToken()}`,
      },
      loading: false,
      columns: [],
      tableBody_item: [],
      fromFields: {},
      modelType: '新增',
    }
  },
  mounted() {
    this.indicatorData()
    this.getColumns() //列表数据初始化
    this.getData() //获取列表数据
  },
  methods: {
    //页数
    pageChange(size) {
      this.form.SkipCount = (size - 1) * this.form.MaxResultCount
      this.getData()
    },
    //每页最大条数
    pagesizeChange(size) {
      this.form.MaxResultCount = size
      this.getData()
    },
    reset() {
      // 清空所有属性值
      Object.keys(this.form).forEach((key) => (this.form[key] = ''))
      this.rangeTime = []
    },
    async resetLastYearUserLeaves() {
      var _this = this
      // 第一次确认
      _this.$Modal.confirm({
        width: 450,
        content:
          '<div style="text-align: center; padding: 10px;padding-right: 30px;">' +
          '<i class="ivu-icon ivu-icon-md-warning" style="font-size: 48px; color: #ff9900; margin-bottom: 15px;"></i>' +
          '<div style="color: #515a6e; font-size: 16px; font-weight: bold; line-height: 1.5;">您即将执行【核销去年结余假期】操作</div>' +
          '<div style="color: #ed4014; font-size: 14px; margin-top: 10px;">此操作不可逆，请谨慎操作！</div>' +
          '</div>',
        okText: '我已知晓，继续',
        cancelText: '取消',
        onOk: () => {
          // 延迟700ms
          setTimeout(() => {
            // 第二次确认
            _this.$Modal.confirm({
              width: 500,
              content:
                '<div style="text-align: center; padding: 10px;padding-right: 30px;">' +
                '<i class="ivu-icon ivu-icon-md-alert" style="font-size: 48px; color: #ff9900; margin-bottom: 15px;"></i>' +
                '<div style="color: #515a6e; font-size: 16px; font-weight: bold; line-height: 1.5;">再次确认：您确定要执行此操作吗？</div>' +
                '<div style="color: #ed4014; font-size: 14px; margin-top: 10px;">此操作将<span style="font-size: 16px; font-weight: bold;">永久核销</span>所有用户的去年结余假期！</div>' +
                '</div>',
              okText: '我确定，继续',
              cancelText: '取消',
              onOk: () => {
                // 延迟700ms
                setTimeout(() => {
                  // 第三次确认
                  _this.$Modal.confirm({
                    width: 500,
                    content:
                      '<div style="text-align: center; padding: 10px; background-color: #fff7e6; border: 1px solid #ff9900; border-radius: 4px;margin-right: 30px;">' +
                      '<i class="ivu-icon ivu-icon-ios-alert" style="font-size: 56px; color: #ed4014; margin-bottom: 15px;"></i>' +
                      '<div style="color: #ed4014; font-size: 18px; font-weight: bold; margin-bottom: 10px;">最后一次确认！</div>' +
                      '<div style="color: #515a6e; font-size: 14px; line-height: 1.6;">【核销去年结余假期】操作即将执行，此操作<span style="color: #ed4014; font-weight: bold;">不可撤销</span>！<br/>请确认您真的要进行此操作！</div>' +
                      '</div>',
                    okText: '我完全确认，执行操作',
                    cancelText: '取消',
                    onOk: async () => {
                      try {
                        let res = await resetLastYearUserLeave()
                        if (res.data.success) {
                          _this.$Message.success('核销成功')
                          _this.getData()
                        } else {
                          var timer = null
                          clearTimeout(timer)
                          timer = setTimeout(() => {
                            _this.$Modal.error({
                              title: '错误',
                              content: res.data.result.message,
                            })
                          }, 1000)
                        }
                      } catch (error) {
                        _this.$Message.error('核销失败，请稍后重试')
                      }
                    },
                  })
                }, 700)
              },
            })
          }, 700)
        },
      })
    },
    //列表数据
    async getData() {
      this.loading = true
      let findData = await this.$Ajax.get(
        `/api/services/app/UserLeave/QueryDto?IncludeLeaveUser=${true}`,
        { params: this.form }
      )
      this.tableBody_item = findData.data.result.items
      this.totalCount = findData.data.result.totalCount
      this.loading = false
    },
    //下拉框数据
    async indicatorData() {
      let indicatorTable = await this.$Ajax.get('/api/services/app/UserLeave/GetLeaveInitData')
      this.fromFields = indicatorTable.data.result
    },
    // 下载导入模板
    downLoadTemplate() {
      this.downloadFile('/Leavefile/DownloadModel', '导入人员假期模板')
    },
    downloadFile(url, title) {
      const date = moment(new Date()).format('yyyyMMDDHHmm')
      let _this = this
      let consturl = this.$constDefinition.baseUrl + url //下载地址url
      var xhr = new XMLHttpRequest()
      xhr.open('get', consturl, true) // get、post都可
      xhr.responseType = 'blob'
      xhr.setRequestHeader('Authorization', `Bearer ${Util.abp.auth.getToken()}`) //加请求头
      xhr.onload = function () {
        console.log(xhr)
        if (xhr.status == 200) {
          let blob = new Blob([this.response], {
            type: 'application/vnd.ms-excel',
          })
          var a = document.createElement('a')
          var url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = title + date + '.xlsx' // 文件名
          if (xhr.readyState === 4) {
            _this.$Message.success({
              content: '下载成功',
              duration: 3,
            })
          }
        } else {
          _this.$Message.error({
            content: '下载失败',
            duration: 3,
          })
        }
        a.click()
        window.URL.revokeObjectURL(url)
      }
      xhr.send()
    },
    //新增
    listTest(type, data) {
      this.modelType = type
      this.testModal = true
      if (type == '编辑') {
        this.$refs.newID.getInforID(data.id)
      }
    },
    //关闭新增编辑弹出框
    close(data) {
      this.testModal = false
      if (data.cancel) {
        this.getData()
      }
    },
    //下载模板
    down(e) {
      window.open(abp.url + e)
    },
    //人员假期导入
    importT() {
      this.testDate = true
      // this.$refs.uploads.clearn();
    },
    closeDate() {
      this.testDate = false
      this.form.skipCount = 0
      this.getData()
    },
    // 导入前处理
    beforeImportFile() {
      this.spinShow = true
    },
    // 导入成功
    importFile() {
      this.$Message.success({
        content: '导入成功',
        duration: 3,
      })
      this.getData()
      this.spinShow = false
    },
    // 导入失败
    errorImportFile(error, file, fileList) {
      this.$Message.error({
        content: file.error.message,
        duration: 3,
      })
      this.getData()
      this.spinShow = false
    },
    closeDate() {
      this.testDate = false
      this.form.skipCount = 0
      this.getData()
    },

    //打开日志弹出框
    openLog(type, data) {
      this.testLog = true
      this.$refs.logID.getLogID(data.id)
    },
    //关闭关闭弹出框
    closeLog(data) {
      this.testLog = false
    },
    exportFile() {
      var _this = this

      this.$downLoad('/api/Export/ExportUserLeaveList', '人员假期', '.xlsx', this.form)
    },
    //table 列
    getColumns() {
      this.columns = [
        {
          title: '操作',
          key: 'Actions',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                  },
                  on: {
                    click: async () => {
                      this.listTest('编辑', params.row)
                    },
                  },
                },
                '编辑'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                  },
                  on: {
                    click: async () => {
                      this.openLog('日志', params.row) //打开操作日志弹出框
                    },
                  },
                },
                '日志'
              ),
			  h(
			    'Button',
			    {
			      props: {
			        type: 'error',
			        size: 'small',
			      },
			      style: {
			        marginRight: '5px',
			        display: params.row.isShow删除 ? '' : 'none',
			      },
			      on: {
			        click: () => {
			          this.$Modal.confirm({
			            title: '确认是否删除？',
			            okText: '确认',
			            cancelText: '取消',
			            onOk: async () => {
			              this.isShowDelete = true
			      
			              const { data } = await this.$Ajax.post(
			                `/api/services/app/UserLeave/DeleteUserLeave?id=${params.row.id}`
			              )
			              if (data.success) {
			                this.$Message.success({ content: '删除成功', duration: 5 })
			              } else {
			                this.$Message.error({ content: '删除失败', duration: 5 })
			              }
			              this.isShowDelete = false
			              this.getData()
			            },
			          })
			        },
			      },
			    },
			    '删除'
			  ),
            ])
          },
        },
        {
          title: '用户名',
          width: 90,
          key: 'name',
          render: (h, params) => {
            return h('span', params.row.leaveUser.name)
          },
        },
        {
          title: '年份',
          width: 80,
          key: 'year',
        },
        {
          title: '年假天数',
          width: 90,
          key: 'annualLeave',
        },
        {
          title: '年假已用天数',
          width: 90,
          key: 'annualLeaveUsed',
        },
        {
          title: '年假剩余天数',
          width: 90,
          key: 'timeRemainingAllnual',
        },
        {
          title: '调休天数',
          width: 90,
          key: 'overtimeLeave',
        },
        {
          title: '调休已用天数',
          width: 90,
          key: 'overtimeLeaveUsed',
        },
        {
          title: '调休剩余天数',
          width: 90,
          key: 'timeRemainingOvertime',
        },
        {
          title: '去年结余年假',
          width: 90,
          key: 'lastYearAnnualLeave',
        },
        {
          title: '结余已用年假',
          width: 90,
          key: 'lastYearAnnualLeaveUsed',
        },
        {
          title: '结余剩余年假',
          width: 90,
          key: 'timeRemainingLastYearAnnual',
        },
        {
          title: '已用事假',
          width: 90,
          key: 'matterLeaveUsed',
        },
        {
          title: '已用婚假',
          width: 90,
          key: 'marriageLeaveUsed',
        },
        {
          title: '已用产假',
          width: 90,
          key: 'maternityLeaveUsed',
        },
        {
          title: '已用丧假',
          width: 90,
          key: 'funeralLeaveUsed',
        },
        {
          title: '已用陪产假',
          width: 90,
          key: 'paternityLeaveUsed',
        },
        {
          title: '已用哺乳假',
          width: 90,
          key: 'breastfeedingLeaveUsed',
        },
        {
          title: '已用病假',
          width: 90,
          key: 'sickLeaveUsed',
        },
        {
          title: '已用工伤假',
          width: 90,
          key: 'workInjuryLeaveUsed',
        },
        {
          title: '过期日期',
          width: 120,
          key: 'expirationTime',
          render: (h, params) => {
            return h('span', moment(params.row.expirationTime).format('YYYY-MM-DD'))
          },
        },
      ]
    },
  },
}
</script>

<style lang="less" scoped="scoped">
.app {
  // min-width: 900px;
}
.ivu-upload {
  display: inline-block;
}
</style>
